// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31xwc","col":"styles_col__1-oSm"};